export default class PreviousJobModel {
  public jobId: string
  public createdAt: Date
  public description: string
  public secondaryDescription?: string
}
